export function formatDateToUTC2(dateString) {
  if (!dateString) return "";

  try {
    // Parse the input date
    const date = new Date(dateString);

    // Check if it's a valid date
    if (isNaN(date.getTime())) {
      return "";
    }

    // Adjust for UTC+2 timezone by adding 2 hours
    const utcPlus2Date = new Date(date.getTime() + 2 * 60 * 60 * 1000);

    // Format date as DD.MM.YYYY (Croatian format)
    const day = String(utcPlus2Date.getUTCDate()).padStart(2, "0");
    const month = String(utcPlus2Date.getUTCMonth() + 1).padStart(2, "0");
    const year = utcPlus2Date.getUTCFullYear();

    return `${day}.${month}.${year}`;
  } catch (error) {
    console.error("Error formatting date:", error);
    return "";
  }
}
